import axios, {type AxiosResponse} from 'axios'
import {catchError, type HttpServiceParamsInterface, redirectToSignIn} from './http.helpers'
import {getStoredToken} from "@shared/helpers";
import {TokenApi} from "@/api";
import {TokenNs} from "@shared/types";
import {useAuthStore} from "@domains/auth/stores/auth.store";
import { v4 as uuidv4 } from 'uuid'

axios.interceptors.request.use(
    config => {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers.common["Authorization"] = token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    (res) => res,
    async (err) => {
        const originalConfig = err.config
        if (err.response && err.response.status === 401) {
            if (originalConfig._retry || originalConfig.url.indexOf('/oauth/token') > 0) {
                redirectToSignIn()
                return Promise.reject(err)
            }
            originalConfig._retry = true
            try {
                const token = getStoredToken()
                if (token && token.refreshToken) {
                    const clientInstanceId = uuidv4()
                    let tokenData = {} as TokenNs.CreateTokenResponse
                    try {
                        tokenData = await TokenApi.createToken({
                            refresh_token: token.refreshToken,
                            grant_type: TokenNs.GrantType.RefreshToken
                        }, clientInstanceId)
                    } catch (error) {
                        redirectToSignIn()
                        return
                    }
                    const accessToken = tokenData.access_token
                    const authStore = useAuthStore();
                    authStore.setToken(tokenData)

                    err.config.headers.Authorization = `Bearer ${accessToken}`
                    return new Promise((resolve, reject) => {
                        axios.request(originalConfig).then((response) => {
                            resolve(response)
                        }).catch((error) => {
                            reject(error)
                        })
                    })
                }else {
                  redirectToSignIn()
                }
            } catch (_error) {
                return Promise.reject(_error)
            }
        }
        return Promise.reject(err)
    }
)

export const httpGet = <T>(params: HttpServiceParamsInterface<void>): Promise<T> => axios.get(params.url, {headers: params.headers})
.then((res) => res.data)
.catch((error) => catchError(error))

export const httpPost = <P, T>(params: HttpServiceParamsInterface<P>): Promise<T> => axios.post(params.url, params.data, {headers: params.headers, onUploadProgress: params.onUploadProgress})
.then((res) => res.data)
.catch((error) => catchError(error))

export const httpPut = <P, T>(params: HttpServiceParamsInterface<P>): Promise<AxiosResponse<T>> => axios.put(params.url, params.data)
.then((res) => res)
.catch((error) => catchError(error))

export const httpPatch = <P, T>(params: HttpServiceParamsInterface<P>): Promise<AxiosResponse<T>> => axios.patch(params.url, params.data)
.then((res) => res)
.catch((error) => catchError(error))

export const httpDelete = <P, T>(params: HttpServiceParamsInterface<P>): Promise<AxiosResponse<T>> => axios.delete(params.url, {
  headers: params.headers,
  data: params.data
})
.then((res) => res)
.catch((error) => catchError(error))
